// MyChecklistCreate.js
import React, { useCallback, useEffect, useState, useRef } from 'react';
import useFetch from '../../hooks/useFetch';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { GenerateThink5whysChecklistCode } from '../../components/GenerateThink5whysCode';

const MyChecklistCreate = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData] = useFetch();
  const navigate = useNavigate();
  const { checklistId } = useParams();
  const mode = checklistId === undefined ? "add" : "update";
  const [checklist, setChecklist] = useState(null);

  const [loading, setLoading] = useState(true);
  const [createSuccess, setCreateSuccess] = useState(false); 
  // const [updateSuccess, setUpdateSuccess] = useState(false); 

  const [createSuccessMsg, setCreateSuccessMsg] = useState('');
  // const [updateSuccessMsg, setUpdateSuccessMsg] = useState(''); 
 
  // const [creatingChecklist, setCreatingChecklist] = useState(false); 
   
  // const [verifyParentChecklistSuccess, setVerifyParentChecklistSuccess] = useState(false); 

  const [errors, setErrors] = useState({});
  const [error, setError] = useState(null);
  const [countFormErrors, setCountFormErrors] = useState(0);
  const [formErrors, setFormErrors] = useState({});
  // const [parentChecklistCreatorName, setParentChecklistCreatorName] = useState(''); 
  const [autoChecklistCode, setAutoTaskCode] = useState(GenerateThink5whysChecklistCode());

  const userId = authState.user._id;

  const [formData, setFormData] = useState({
    createdBy: authState.user._id,
    creatorCode: authState.user.think5whyscode,
    creatorName: authState.user.name,
    checklistType: 'Unspecified', 
    checklistCode: autoChecklistCode, 
    checklistTitle: '',
    checklistDesc: '',
    checklistDos: '',
    checklistDont: '',
    dateCreated: new Date(),
    isActive: true,
    isDeleted: false,
    entityCode: '',
    myChecklistMembers: null,
  });

  // const [createClicked, setCreateClicked] = useState(false);

  useEffect(() => {
    document.title = mode === "add" ? "Add" : "Update";
  }, [mode]);

  useEffect(() => {
    if (mode === "update") {
      const config = { 
        url: `/mychecklist/getforupdate`, 
        method: "post", 
        headers: { Authorization: authState.token }, 
        data: {checklistId: checklistId}
      };
      // console.log("Getting Data for Update here",config);
      // console.log("Existing formData",formData);

      fetchData(config, { showSuccessToast: false }).then((data) => {
        // console.log("response for update - ",data.checklist);
        setChecklist(data.checklist);
        setFormData({
          checklistType: data.checklist.checklistType,
          checklistCode: data.checklist.checklistCode,
          checklistTitle: data.checklist.checklistTitle,
          checklistDesc: data.checklist.checklistDesc,
          checklistDos: data.checklist.checklistDos,
          checklistDont: data.checklist.checklistDont,
          entityCode: data.checklist.entityCode,
          myChecklistItems: data.checklist.myChecklistItems,
          creatorCode: data.checklist.creatorCode,
          creatorName: data.checklist.creatorName,
          dateCreated: new Date(data.checklist.dateCreated),
          createdBy: data.checklist.createdBy,
          isActive: data.checklist.isActive,
          isDeleted: data.checklist.isDeleted,
        });
      })
      .catch((error) => {
        console.error("Error fetching Checklist data:", error);
        setError("Error fetching Checklist data");
      });
    }
  }, [mode, authState, checklistId, fetchData, setChecklist]);

  const handleReset = e => {
    e.preventDefault();
    setFormData({
      checklistType: checklist.checklistType,
      checklistCode: checklist.checklistCode,
      checklistTitle: checklist.checklistTitle,
      checklistDesc: checklist.checklistDesc,
      checklistDos: checklist.checklistDos,
      checklistDont: checklist.checklistDont,
      entityCode: checklist.entityCode,
      myChecklistItems: checklist.myChecklistItems,
      creatorCode: checklist.creatorCode,
      creatorName: checklist.creatorName,
      dateCreated: new Date(checklist.dateCreated),
      createdBy: checklist.createdBy,
      isActive: checklist.isActive,
      isDeleted: checklist.isDeleted,
    });
  }

  const handleSubmit = e => {
    e.preventDefault();
    const error = validateForm(formData);
    // console.log("error : ",error," no. of error",Object.keys(error).length);
    setFormErrors(error);
    setCountFormErrors(Object.keys(error).length);
    // console.log("setFormError : ",setFormErrors);

    if (Object.keys(error).length > 0) {
      setFormErrors(
        Object.keys(error).reduce((total, key) => {
          total[key] = error[key];
          return total;
        }, {})
      );
      return;
    }

    if (mode === "add") {
      const config = { 
        url: "/mychecklist", 
        method: "post",
        data: {formData: formData, user: authState.user._id}, 
        headers: { Authorization: authState.token } 
      };
      // console.log("Posting mychecklist Data ",JSON.stringify(formData, null, 2), " User ",authState.user._id);

      fetchData(config).then(() => {
        navigate("/myprofile-checklist");
      });
    }
    else {
      // console.log("checklist id for upadate", checklistId);
      const config = { 
        url: `/mychecklist/${checklistId}`, 
        method: "put", 
        data: formData, 
        headers: { Authorization: authState.token } 
      };
      // console.log("Posting checklist Data for update ",config);

      fetchData(config).then(() => {
        navigate("/myprofile-checklist");
      })
      .catch((error) => {
        console.error("Error updating Checklist:", error);
        setError("Error updating Checklist");
      });
    }
  }

  const validateForm = formData => {
    const errors = {};
    if (!formData.checklistType) {
      errors.purpose = "Please select a type";
    }
    if (!formData.checklistTitle) {
      errors.checklistTitle = "Checklist Title is required";
    } else if (formData.checklistTitle.length > 100) {
      errors.checklistTitle = "Checklist Title cannot exceed 100 characters";
    }
    return errors;
  }

  const fieldError = (field) => (
    <p className={`mt-1 text-pink-600 text-sm ${formErrors[field] ? "block" : "hidden"}`}>
      <i className='mr-2 fa-solid fa-circle-exclamation'></i>
      {formErrors[field]}
    </p>
  )

  const handleCreateClick = () => {
    if(formData.checklistTitle==='')
      {
        errors.checklistTitle="Title Must Not Be Blank";
        return;
      }
    setCreatingChecklist(true);
    fetchChecklistCreate();
  };

  const fetchChecklistCreate = useCallback(() => {
    // console.log('userId:', userId);
  
    try {
      const config = {
        url: "/mychecklist",
        method: 'post',
        data: formData,
        headers: { Authorization: authState.token },
      };
  
      // console.log('Creating checklist with config:', config);
  
      fetchData(config)
        .then(response => {
          if (response && response.status) {
            // console.log("Checklist created successfully:", response);
            setCreateSuccess(true);
            setCreateSuccessMsg("Checklist Created Successfully");
            navigate("/myprofile-checklist");
          } else {
            console.error("Failed to create profile:", response);
            setCreateSuccessMsg("Sorry! Profile Not Created. Please retry.");
          }
        })
        .catch(error => {
          console.error("Error creating profile:", error);
          setCreateSuccessMsg("Sorry! Profile Not Created. Please retry.");
        });
    } catch (error) {
      console.error('Error in fetchProfileCreate:', error);
      setCreateSuccessMsg("Sorry! Profile Not Created. Please retry.");
    }
  }, [userId, formData, authState, fetchData, setCreateSuccess, setCreateSuccessMsg]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
}, [authState.isLoggedIn, fetchChecklistCreate, setCreateSuccess, setCreateSuccessMsg]);

  const handleBackToMyCheckListClick = () => {
    navigate('/myprofile-checklist');
  };

  // const handleUpdateClick = async () => {
  //     const config = { 
  //     url: `/mychecklist/updatechecklist`, 
  //     method: "post", 
  //     data: {formData: formData, checklistId: formData._id}, 
  //     headers: { Authorization: authState.token } 
  //   };
  //   console.log("Posting Data for mychecklist",config);

  //   fetchData(config).then(() => {
  //     navigate("/myprofile-checklist");
  //   })
  //   .catch((error) => {
  //     console.error("Error updating Checklist Master:", error);
  //     setError("Error updating Checklist Master");
  //   });
  // };

  return (
    <MainLayout>
      <div className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>
        <h2>Profile - Master Checklist Creation</h2>
      </div>
      <div className="m-auto my-2 p-2 border-2 shadow-md rounded-md md:w-7/12 w-full text-white text-sm">
        <div className="flex flex-col mt-2 ml-4 mr-4">
          <div>
            <p className='text-sm text-yellow-200 mr-2'>Think5Whys Master Checklist Code: {autoChecklistCode} </p>
          </div>
          <div>
            <p className='text-sm text-white mb-1 mt-2'>Input Checklist Title: </p>
          </div>          
          
        </div>
        {/* {createSuccess && ( */}
          {/* <div className='text-sm'> */}
            {/* <div className="mt-2 border-t">
              <p className='text-lg text-green-400'>Master Checklist {formData.checklistTitle} Created Successfully!</p>
              <p className='text-lg text-orange-400'>Fill the other details!</p>
            </div> */}
            
            <div className="ml-4 mr-4 flex flex-col mt-1 text-sm">
                {/* <div className='w-6/12 flex flex-row mt-2'> */}
                <input
                  type="text"
                  className="profile-input text-black"
                  style={{
                    border: '1px solid #ccc',
                    padding: '8px',
                    width: '90%',
                    boxSizing: 'border-box',
                  }} 
                  value={formData.checklistTitle}
                  onChange={(e) => setFormData({ ...formData, checklistTitle: e.target.value })}
                  placeholder="Enter checklist title"
                />
              {/* </div> */}
              <label>Checklist Type:</label>
              <select className="w-80 h-10 text-black" value={formData.checklistType} onChange={(e) => setFormData({ ...formData, checklistType: e.target.value })}>
                <option value="">Select checklist type</option>
                <option value="adaptive-actions">Adaptive Actions Checklist</option>
                <option value="anger-management">Anger Management Checklist</option>
                <option value="bod">Beginning of Day (BOD) Checklist</option>
                <option value="budgeting">Budgeting Checklist</option>
                <option value="maintenance">Maintenance Checklist</option>
                <option value="child-care">Child Care Checklist</option>
                <option value="cleaning">Cleaning Checklist</option>
                <option value="corrective-actions">Corrective Actions Checklist</option>
                <option value="daily-routine">Daily Routine Checklist</option>
                <option value="delivery">Delivery Checklist</option>
                <option value="dispatch">Dispatch Checklist</option>
                <option value="eod">End of Day (EOD) Checklist</option>
                <option value="event-planning">Event Planning Checklist</option>
                <option value="exercise">Exercise Checklist</option>
                <option value="fire-safety">Fire-Safety Checklist</option>
                <option value="frequent-travel">Frequent Travel Checklist</option>
                <option value="gardening">Gardening Checklist</option>
                <option value="grocery-shopping">Grocery Shopping Checklist</option>
                <option value="home-check">Home Check Checklist</option>
                <option value="home-chore">Home Chore Checklist</option>
                <option value="holiday-preparation">Holiday Preparation Checklist</option>
                <option value="housekeeping">Housekeeping Checklist</option>
                <option value="hygiene">Hygiene Checklist</option>
                <option value="meeting-preparation">Meeting Preparation Checklist</option>
                <option value="moving-house">Moving House Checklist</option>
                <option value="personal-chore">Personal Chore Checklist</option>
                <option value="pet-care">Pet Care Checklist</option>
                <option value="perfetive-actions">Perfective Actions Checklist</option>
                <option value="preventive-actions">Preventive Actions Checklist</option>
                <option value="project-planning">Project Planning Checklist</option>
                <option value="quality">Quality Checklist</option>
                <option value="safety">Safety Checklist</option>
                <option value="self-discipline">Self Discipline Checklist</option>
                <option value="self-improvement">Self Improvement Checklist</option>
                <option value="study">Study Checklist</option>
                <option value="treatment">Treatment Checklist</option>
                <option value="unspecified">Unspecified Checklist</option>
              </select>
              {errors.checklistType && <span className="error">{errors.checklistType}</span>}
          {/* </div>
          <div className="flex flex-col"> */}
            <label>Checklist Description</label>
            <textarea
              className="profile-textarea"
              style={{
                border: '1px solid #ccc',
                padding: '2px',
                backgroundColor: '#f0f0f0', 
                color: '#000000',
                maxWidth: '650px', 
                maxHeight: '150px' 
              }}
              value={formData.checklistDesc}
              onChange={(e) => setFormData({ ...formData, checklistDesc: e.target.value })}
              placeholder="Enter checklist description"
            />
          {/* </div>
          <div className="flex flex-col"> */}
            <label>Checklist Do's</label>
            <textarea
              className="profile-textarea"
              style={{
                border: '1px solid #ccc',
                padding: '2px',
                backgroundColor: '#f0f0f0', 
                color: '#000000',
                maxWidth: '650px', 
                maxHeight: '150px' 
              }}
              value={formData.checklistDos}
              onChange={(e) => setFormData({ ...formData, checklistDos: e.target.value })}
              placeholder="Enter checklist do's"
            />
          {/* </div>
          <div className="flex flex-col"> */}
            <label>Checklist Don'ts</label>
            <textarea
              className="profile-textarea"
              style={{
                border: '1px solid #ccc',
                padding: '2px',
                backgroundColor: '#f0f0f0', 
                color: '#000000',
                maxWidth: '650px', 
                maxHeight: '150px' 
              }}
              value={formData.checklistDont}
              onChange={(e) => setFormData({ ...formData, checklistDont: e.target.value })}
              placeholder="Enter checklist don'ts"
            />
          </div>
          {/* <div className="border flex justify-center flex-col mt-4">
            <div className="flex justify-center flex-row mt-4">
                {error !== '' && (
                  <p className='text-red-500 text-lg'>{error}</p>
                )}
            </div>
            <div className="flex justify-center mt-4">
            <button
              className='bg-purple-700 mt-2'
              onClick={handleCreateClick}
              // disabled={createSuccess}
              style={{ maxWidth: '250px' }}
            >
              Create Master Checklist
            </button>
            <br/>
            {errors.checklistTitle !== '' && (
              <p className='text-red-500 text-lg'>{errors.checklistTitle}</p>
            )}
            </div>
            <div className="flex justify-center flex-row mt-4">
              <button
                className='bg-purple-700'
                onClick={handleUpdateClick}
                style={{ maxWidth: '150px' }}
              >
                Update
              </button>
              <button
                className='bg-purple-700 ml-4'
                onClick={handleBackToMyCheckListClick}
                style={{ maxWidth: '250px' }}
              >
                Back To My Checklist
              </button>
              </div>
          </div> */}
          <div className="border-container flex flex-col justify-center">
                  <div className="flex justify-center">
                    {Object.keys(formErrors).length > 0 && (
                      <div className="form-errors text-red-300 justify-center items-center">
                        {Object.keys(formErrors).map((key) => (
                          <div className="flex justify-center items-center" key={key}>{formErrors[key]}</div>
                        ))}
                      </div>
                    )}
                  </div>

                  { mode == 'update' && (
                      <div>
                      <label>
                        <input 
                          className='mr-4' 
                          type="checkbox" 
                          onChange={(e) => setIsUpdateLock(e.target.checked)} 
                        />
                      </label>
                    </div>
                  )}
                  <div className="flex justify-center">
                    <button 
                      className='bg-primary text-white px-4 py-2 font-medium hover:bg-primary-dark' 
                      onClick={handleSubmit}>
                        {mode === "add" ? "Add New" : "Update"}
                    </button>
                    <button 
                      className='ml-4 bg-red-500 text-white px-4 py-2 font-medium' 
                      onClick={() => navigate("/myprofile-checklist")}>
                        Cancel
                    </button>
                    {mode === "update" && <button className='ml-4 bg-blue-500 text-white px-4 py-2 font-medium hover:bg-blue-600' onClick={handleReset}>Reset</button>}
                  </div>
                </div>
        {/* </div> */}
        {/* )} */}
      </div>
    </MainLayout>
  );
};

export default MyChecklistCreate;
